import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom';
import { FarmersService } from '~/api/services/farmers';
import Drawer from '~/components/Drawer';
import { FormFields } from '~/components/FormFields';
import { emailRegex } from '~/components/FormFields/constants';
import notify from '~/components/Notify';
import { LocationEl } from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/Locations/style';
import { GlobalEl } from '~/styles/app';
import { Nullable } from '~/types';
import { handleErrors } from '~/utils/helpers';

interface Props {
  contactId: Nullable<string>;
  handleHiddenDrawer: (submited?: boolean) => void;
}

const defaultValues = {
  firstName: '',
  lastName: '',
  email: '',
  position: '',
  mobileNumber: '',
  phoneNumber: ''
}

const CreateEditContact:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { contactId, handleHiddenDrawer } = props
  const { id } = useParams()

  const [isBusy, setIsBusy] = useState(false)

  const { handleSubmit, control, reset } = useForm({
    mode: 'onSubmit'
  })

  useEffect(() => {
    if(contactId && contactId === 'create') {
      reset(defaultValues)
    } else if (contactId && contactId !== 'create') {
      fetchContactData()
    }
  }, [contactId])

  async function fetchContactData() {
    setIsBusy(true)
    try {
      const response = await FarmersService.getContact(id, contactId)
      reset(response.data)
    }catch(error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      if(contactId === 'create') {
        await FarmersService.storeContact(id, data)
        notify(t('Successfully create contact'), 'success')
      } else if (contactId && contactId !== 'create') {
        await FarmersService.updateContact(id, contactId, data)
        notify(t('Successfully updated contact'), 'success')
      }
      handleHiddenDrawer(true)
    }catch(error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderContent() {
    return <>
      <FormFields.Input
        control={control}
        name={'firstName'}
        label={t('First name')}
        placeholder={t('Enter first name')}
        rules={{
          required: t('Please enter first name'),
          maxLength: {
            value: 100,
            message: t('Max char. number is 100')
          }
        }}
      />
      <FormFields.Input
        control={control}
        name={'lastName'}
        label={t('Last name')}
        placeholder={t('Enter last name')}
        rules={{
          required: t('Please enter last name'),
          maxLength: {
            value: 100,
            message: t('Max char. number is 100')
          }
        }}
      />
      <FormFields.Input
        control={control}
        name={'position'}
        label={t('Position')}
        placeholder={t('Enter position')}
        rules={{
          maxLength: {
            value: 150,
            message: t('Max char. number is 150')
          }
        }}
      />
      <FormFields.Input
        control={control}
        name={'mobileNumber'}
        label={t('Mobile number')}
        placeholder={t('Enter mobile number')}
        rules={{
          maxLength: {
            value: 30,
            message: t('Max char. number is 30')
          }
        }}
      />
      <FormFields.Input
        control={control}
        name={'phoneNumber'}
        label={t('Phone number')}
        placeholder={t('Enter phone number')}
        rules={{
          maxLength: {
            value: 30,
            message: t('Max char. number is 30')
          }
        }}
      />
      <FormFields.Input
        control={control}
        name={'email'}
        label={t('Email')}
        placeholder={t('Enter email')}
        rules={{
          maxLength: {
            value: 50,
            message: t('Max char. number is 50')
          },
          pattern: {
            value: emailRegex,
            message: t('Please enter valid email')
          }
        }}
      />
      <LocationEl.DrawerFooter>
        <GlobalEl.PrimaryButton
        >{contactId === 'create' ? t('Add') : t('Update')}</GlobalEl.PrimaryButton>
      </LocationEl.DrawerFooter>
    </>
  }

  return <Drawer
    onHide={() => {
      reset();
      handleHiddenDrawer();
    }}
    handleSubmit={handleSubmit(onSubmit)}
    isBusy={isBusy}
    header={contactId === 'create' ? t('Add new contact') : t('Edit contact')}
    content={renderContent()}
    isVisible={Boolean(contactId)}
    closeOnEscape
  />
}
export default CreateEditContact